import { getProperty } from './getProperty';
import * as browser from 'bowser';

export function debug(message: any, ...params: any[]): void {
  if (params && params.length > 0) {
    if (console) {
      console.log(message, params);
    }
  } else {
    if (console) {
      console.log(message);
    }
  }
}

export function removeNonDigit(value: string): string {
  value = value || '';
  return value.replace(/\D/g, '');
}

export function removeAccents(accentedWord: string) {
  if (!accentedWord) {
    return;
  }
  let input = accentedWord.toString().toLowerCase();
  const accentedMapHex = {
    a: /[\xE0-\xE6]/g,
    e: /[\xE8-\xEB]/g,
    i: /[\xEC-\xEF]/g,
    o: /[\xF2-\xF6]/g,
    u: /[\xF9-\xFC]/g,
    c: /\xE7/g,
    n: /\xF1/g,
  };

  for (const letter of Object.keys(accentedMapHex)) {
    const regex = accentedMapHex[letter];
    input = input.replace(regex, letter);
  }
  return input;
}

/**
 * Recebe uma string em qualquer formatado e devolve somente numeros
 *
 * @type {string}
 */
export function parseDecimal(value: string): string {
  value = value || '';
  return value.replace(/\D/g, '');
}

/**
 * Objeto com métodos rápidos para identificar dispositivo
 */
export const device = {
  mobile() {
    return browser.mobile;
  },
  desktop() {
    return !browser.mobile;
  },
  type() {
    return browser.mobile ? 'mobile' : 'webdesktop';
  },
  ios() {
    return getProperty(browser, 'ios', false);
  },
  chrome() {
    return browser.chrome || browser.chromium;
  },
  safari() {
    return browser.safari;
  },
  msie() {
    const re = new RegExp('Trident/.*rv:([0-9]{1,}[.0-9]{0,})');
    return re.exec(navigator.userAgent) != null ? false : true;
  },
  windows() {
    return browser.windows;
  },
  platform() {
    const system = browser._detect(window.navigator.userAgent);
    return system ? getProperty(system, 'osname') : null;
  },
};
